'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { composeHandlers } from '@s7/react-utils';
import { TabNavigation } from '@s7/ui';
import { useAnalytics } from './analytics.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const TabNavigationWidgetItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { value, onClick, activeTab } = props;
    const navigationTopic = useAnalytics('navigation');
    return /*#__PURE__*/ jsx(TabNavigation.Item, _extends({
        ref: ref,
        onClick: composeHandlers(()=>navigationTopic == null ? void 0 : navigationTopic.openTab(activeTab != null ? activeTab : '', value), onClick)
    }, props));
});

export { TabNavigationWidgetItem };
//# sourceMappingURL=TabNavigationWidgetItem.js.map
